import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ca-apeer-alert',
    templateUrl: './apeer-alert.component.html',
    styleUrls: ['./apeer-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApeerAlertComponent {
    @Input() type: AlertType = 'info';

    title = this.translateService.instant('MACHINE_LEARNING.GREAT_ML_EXPERIENCE.TITLE');

    constructor(private translateService: TranslateService) {}
}

type AlertType = 'info' | 'danger' | 'warning' | 'success';
